import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { getSelectedProgramPlan } from "./utils";

const ProgramFreeTrialPlan = props => {
  const [fee, setFee] = useState("Loading");
  const calculateFee = () => {
    const plan = getSelectedProgramPlan(props.program, props.selected);
    setFee(parseFloat(plan.total_price).toFixed(2));
  };
  useEffect(() => {
    calculateFee();
  }, []);
  return (
    <li
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "15px 10px",
        borderBottom: "1px solid #dedede"
      }}
    >
      <p
        style={{
          marginBottom: 0,
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 500,
          fontSize: "14px"
        }}
      >
        Free Trial Plan - {getSelectedProgramPlan(props.program, props.selected).trialPeriod} classes
      </p>
      <span style={{ fontWeight: 500, fontSize: "14px" }}>${fee}</span>
    </li>
  );
};

ProgramFreeTrialPlan.propTypes = {
  program: PropTypes.shape({
    plans: PropTypes.array.isRequired
  }).isRequired,
  selected: PropTypes.number.isRequired
};

export default ProgramFreeTrialPlan;
